function getNestedPropByID(ArrayToSearch, ID, prop, prop_path) {
  const data = ArrayToSearch.find((member) => member._id === ID);
  return data && data[prop_path] && data[prop_path][prop]
    ? data[prop_path][prop]
    : "Not Found";
}

module.exports = getNestedPropByID;
